$(function() {
  const shop_list = $('.product-grid');
  const products = shop_list.find('li.grid__item');
  const productCount = products.length;

  const bannerWraps = $('.shop_list_banner_wrap');
  if (bannerWraps.length === 0) return;

  const banners = bannerWraps.map(function() {
    return $(this).html();
  }).get();

  bannerWraps.hide();

  let insertPositions = [];

  if (productCount >= 8) {
    insertPositions = [3, 9];
  } else if (productCount >= 4 && productCount <= 7) {
    insertPositions = [4, 5];
  } else if (productCount <= 3) {
    //insertPositions = ['end'];
  }

  insertPositions.forEach((pos, idx) => {
    const bannerHtml = banners[idx % banners.length];
    const bannerItem = $('<li class="grid__item shop_list_banner_item">' + bannerHtml + '</li>');

    if (pos === 'end') {
      shop_list.append(bannerItem);
    } else {
      const target = products.eq(pos - 1);
      if (target.length) {
        bannerItem.insertBefore(target);
      } else {
        shop_list.append(bannerItem);
      }
    }
  });
});
